<div class="notification-card-wrapper">
    <ng-container *ngFor="let notification of notificationsService.notificationsCache; let i =index; ">
        <mat-card *ngIf="notification.type === notificationType" (click)="routeTo(notification.route)"
            class="card-bg notification-card position-relative border-field pad-4-hr margin-8"
            [ngClass]="{'cursor-pointer-outline': notification.route}">
            <img *ngIf="!notification.isRead" class="notify-icon position-absolute" src="/assets/icons/notify_icon.png">
            <mat-card-header>
                <mat-card-title>
                    <div>
                        <span class="font-14" [innerHtml]="notification.title"></span>
                    </div>
                </mat-card-title>
                <mat-card-subtitle>
                    <div>
                        <span class="font-12" [innerHtml]="notification.message "></span>
                    </div>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-actions align="end">
                <div>
                    <span class="placeholder-text font-12">
                        {{ notification.time | date:DATE_TIME_FORMAT }}
                    </span>
                </div>
            </mat-card-actions>
        </mat-card>
    </ng-container>

    <ng-container *ngIf="notificationType === NotificationType.Offers">
        <!-- <div *ngIf="showPlanExtendedOffer" class="display-flex pad-4-hr">
            <div class="width-10 head-left border-field extend-notification-header">
                <img src="/assets/icons/gift.svg">
            </div>
            <div class="width-90 pad-8 border-field head-right">
                <div class="width-90 margin-32-left font-12">
                    <div class="font-14 font-bold">
                        Here’s a special offer just for you!
                    </div>
                    <div class="margin-8-top">
                        We appreciate you using our service, and as a token of our gratitude, we're offering you an extra {{free_plan_extension_days}} days on your free plan.
                    </div>
                    <div class="cursor-pointer margin-8-top decoration-underline extend-plan-action" (click)="openExtendPlan()">
                        Claim Offer
                    </div>
                </div>
            </div>
        </div> -->
        <div *ngIf="showDiyUpdateNotification && !hidePlans" class="display-flex pad-4-hr">
            <div class="width-10 head-left border-field extend-notification-header">
                <img src="/assets/images/megaphone.svg">
            </div>
            <div class="width-90 pad-8 border-field head-right">
                <div class="width-90 margin-32-left font-12">
                    <div class="font-14 font-bold">
                        Announcement
                    </div>
                    <div class="margin-8-top">
                        We've recently updated our subscription plans. These changes may affect your current plan and benefits. Please review the updated plans to ensure your subscription continues without interruption.
                    </div>
                    <div class="cursor-pointer margin-8-top decoration-underline extend-plan-action" (click)="openPricingDialog()">
                        View Plans and Pricing
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>